// extracted by mini-css-extract-plugin
module.exports = {"title":"DeclineOfferModal_title__1Knp_","generalInput":"DeclineOfferModal_generalInput__MeBAZ","nextButton":"DeclineOfferModal_nextButton__1Ooe7"};